<template>
  <v-card class="mb-5">
    <v-card-title class="primary white--text">Latest Activity</v-card-title>
    <v-card-text class="py-0">
      <v-timeline dense>
        <v-slide-x-reverse-transition group hide-on-leave>
          <v-timeline-item
            v-for="item in items"
            :key="item._id"
            :color="getColour(item)"
            small
            fill-dot
          >
            <v-alert :value="true" color="grey lighten-4" :icon="getIcon(item)">
              <div>{{ item.caption }}</div>
              <div class="font-weight-bold mt-1">- {{ item.userName }}</div>
            </v-alert>
          </v-timeline-item>
        </v-slide-x-reverse-transition>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
const ICONS = {
  create: 'mdi-plus-circle',
  update: 'mdi-circle-edit-outline',
  delete: 'mdi-delete-circle'
};

const COLOURS = {
  create: 'green lighten-2',
  update: 'blue lighten-2',
  delete: 'red lighten-2'
};

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    candidate: Object
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      logs: state => state.logs
    }),
    items() {
      return this.logs.items.slice(0, 5);
    }
  },
  methods: {
    ...mapActions({
      getLogs: 'logs/fetchLogs',
      deleteLogs: 'logs/deleteLogs'
    }),
    getIcon(log) {
      return log.action === 'create'
        ? ICONS.create
        : log.action === 'update'
        ? ICONS.update
        : ICONS.delete;
    },
    getColour(log) {
      return log.action === 'create'
        ? COLOURS.create
        : log.action === 'update'
        ? COLOURS.update
        : COLOURS.delete;
    }
  },
  mounted() {
    this.getLogs();
  }
};
</script>
